<template>
  <button
    :class="computedClasses"
    @click="$emit('click')"
  >
    <font-awesome-icon v-if="icon" :icon="icon" :class="iconSize" />
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: "BaseFab",
  props: {
    icon: {
      type: [String, Array],
      default: null,
    },
    variant: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: "md", // sm | md | lg
      validator: (v) => ["sm", "md", "lg"].includes(v),
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      const base =
        "flex items-center justify-center rounded-full transition-all duration-200 focus:outline-none";

      const variants = {
        primary: "text-white bg-ppd-green-light hover:bg-ppd-green-dark",
        secondary: "text-gray-700 border border-gray-400 bg-white hover:bg-gray-100",
        danger: "text-white bg-red-600 hover:bg-red-700",
        info: "text-white bg-blue-600 hover:bg-blue-700",
      };

      const sizes = {
        sm: "w-10 h-10",
        md: "w-12 h-12",
        lg: "w-16 h-16",
      };

      const position = this.fixed ? "fixed bottom-6 right-6" : "";

      return `${base} ${variants[this.variant] || variants.primary} ${sizes[this.size]} ${position}`;
    },
    iconSize() {
      return {
        sm: "text-base",
        md: "text-xl",
        lg: "text-2xl",
      }[this.size];
    },
  },
};
</script>

<style scoped>
    .bg-ppd-green-light {
    background-color: #16663e;
    }
    .bg-ppd-green-dark {
    background-color: #0f4f2f;
    }
</style>
